"use client";
import * as React from "react";
import { forwardRef } from "react";
import { ButtonProps } from "../types";
import styles from "./index.module.css";
import Spinner from "../Spinner/index";
import LeftArrowIcon from "../icons/LeftArrow";
import RightArrowIcon from "../icons/RightArrow";

const Button = forwardRef<ButtonProps["buttonRef"]>(function Button(
  props: ButtonProps,
  buttonRef
) {
  function buttonHTMLAttributes() {
    const {
      buttonRef,
      name,
      handleClick,
      type,
      variant,
      classNames,
      isLoading,
      ...rest
    } = props;
    return rest;
  }

  function variantCss() {
    return props.variant ? " " + styles[props.variant] : "";
  }

  return (
    <button
      ref={buttonRef}
      type={props.type || "button"}
      className={`${styles.btn}${variantCss()}${
        props.classNames ? " " + props.classNames : ""
      }`}
      disabled={props.isLoading}
      onClick={(event) => props.handleClick?.(event)}
      {...buttonHTMLAttributes()}
    >
      {props.isLoading ? (
        <Spinner variant="small" color="currentColor" />
      ) : null}
      {props.icon === "LeftArrowIcon" ? (
        <LeftArrowIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles.icon,
          }}
        />
      ) : null}
      {props.icon === "RightArrowIcon" ? (
        <RightArrowIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles.icon,
          }}
        />
      ) : null}
      {props.name}
    </button>
  );
});

export default Button;
